export const NOTIFICATION_TIMEOUT = 6000
export const ERROR_NOTIFICATION_TIMEOUT = 12000
